{
  "labels": {
    "paste": "Plakken",
    "pasteAsPlaintext": "Plakken als platte tekst",
    "pasteCharts": "Plak grafieken",
    "selectAll": "Alles selecteren",
    "multiSelect": "Voeg element toe aan selectie",
    "moveCanvas": "Canvas verplaatsen",
    "cut": "Knip",
    "copy": "Kopiëren",
    "copyAsPng": "Kopieer als PNG",
    "copyAsSvg": "Kopieer naar klembord als SVG",
    "copyText": "Kopieer naar klembord als tekst",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Breng naar voren",
    "sendToBack": "Stuur naar achtergrond",
    "bringToFront": "Breng naar voorgrond",
    "sendBackward": "Breng naar achter",
    "delete": "Verwijderen",
    "copyStyles": "Kopieer opmaak",
    "pasteStyles": "Plak opmaak",
    "stroke": "Lijn",
    "background": "Achtergrond",
    "fill": "Invulling",
    "strokeWidth": "Lijnbreedte",
    "strokeStyle": "Lijnstijl",
    "strokeStyle_solid": "Ononderbroken",
    "strokeStyle_dashed": "Gestreept",
    "strokeStyle_dotted": "Gestippeld",
    "sloppiness": "Slordigheid",
    "opacity": "Doorzichtigheid",
    "textAlign": "Uitlijning",
    "edges": "Randen",
    "sharp": "Hoekig",
    "round": "Rond",
    "arrowheads": "Pijlpunten",
    "arrowhead_none": "Geen",
    "arrowhead_arrow": "Pijl",
    "arrowhead_bar": "Balk",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Driehoek",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Tekstgrootte",
    "fontFamily": "Lettertype",
    "addWatermark": "Voeg \"Gemaakt met Excalidraw\" toe",
    "handDrawn": "Handgetekend",
    "normal": "Normaal",
    "code": "Code",
    "small": "Klein",
    "medium": "Medium",
    "large": "Groot",
    "veryLarge": "Zeer groot",
    "solid": "Ingekleurd",
    "hachure": "Arcering",
    "zigzag": "",
    "crossHatch": "Tweemaal gearceerd",
    "thin": "Dun",
    "bold": "Vet",
    "left": "Links",
    "center": "Midden",
    "right": "Rechts",
    "extraBold": "Zwaar",
    "architect": "Architect",
    "artist": "Artiest",
    "cartoonist": "Cartoonist",
    "fileTitle": "Bestandsnaam",
    "colorPicker": "Kleurenkiezer",
    "canvasColors": "Gebruikt op canvas",
    "canvasBackground": "Canvas achtergrond",
    "drawingCanvas": "Canvas",
    "layers": "Lagen",
    "actions": "Acties",
    "language": "Taal",
    "liveCollaboration": "Live Samenwerking...",
    "duplicateSelection": "Dupliceer",
    "untitled": "Naamloos",
    "name": "Naam",
    "yourName": "Jouw naam",
    "madeWithExcalidraw": "Gemaakt met Excalidraw",
    "group": "Groeperen",
    "ungroup": "Groep opheffen",
    "collaborators": "Deelnemers",
    "showGrid": "Raster weergeven",
    "addToLibrary": "Voeg toe aan bibliotheek",
    "removeFromLibrary": "Verwijder uit bibliotheek",
    "libraryLoadingMessage": "Bibliotheek laden…",
    "libraries": "Blader door bibliotheken",
    "loadingScene": "Scène laden…",
    "align": "Uitlijnen",
    "alignTop": "Boven uitlijnen",
    "alignBottom": "Onder uitlijnen",
    "alignLeft": "Links uitlijnen",
    "alignRight": "Rechts uitlijnen",
    "centerVertically": "Verticaal Centreren",
    "centerHorizontally": "Horizontaal Centreren",
    "distributeHorizontally": "Horizontaal verspreiden",
    "distributeVertically": "Verticaal distribueren",
    "flipHorizontal": "Horizontaal spiegelen",
    "flipVertical": "Verticaal spiegelen",
    "viewMode": "Weergavemodus",
    "share": "Deel",
    "showStroke": "Toon lijn kleur kiezer",
    "showBackground": "Toon achtergrondkleur kiezer",
    "toggleTheme": "Thema aan/uit",
    "personalLib": "Persoonlijke bibliotheek",
    "excalidrawLib": "Excalidraw bibliotheek",
    "decreaseFontSize": "Letters verkleinen",
    "increaseFontSize": "Letters vergroten",
    "unbindText": "Ontkoppel tekst",
    "bindText": "Koppel tekst aan de container",
    "createContainerFromText": "",
    "link": {
      "edit": "Wijzig link",
      "editEmbed": "Link bewerken & insluiten",
      "create": "Maak link",
      "createEmbed": "Link maken en insluiten",
      "label": "Link",
      "labelEmbed": "Link toevoegen & insluiten",
      "empty": "Er is geen link ingesteld"
    },
    "lineEditor": {
      "edit": "Bewerk regel",
      "exit": "Verlaat regel-editor"
    },
    "elementLock": {
      "lock": "Vergrendel",
      "unlock": "Ontgrendel",
      "lockAll": "Vergrendel alles",
      "unlockAll": "Ontgrendel alles"
    },
    "statusPublished": "Gepubliceerd",
    "sidebarLock": "Zijbalk open houden",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Nog geen items toegevoegd...",
    "hint_emptyLibrary": "Selecteer een item op het canvas om het hier toe te voegen of installeer een bibliotheek uit de openbare repository, hieronder.",
    "hint_emptyPrivateLibrary": "Selecteer een item op het canvas om het hier toe te voegen."
  },
  "buttons": {
    "clearReset": "Canvas opnieuw instellen",
    "exportJSON": "Exporteren naar bestand",
    "exportImage": "Exporteer afbeelding...",
    "export": "Sla op...",
    "copyToClipboard": "Kopieer",
    "save": "Opslaan naar huidige bestand",
    "saveAs": "Opslaan als",
    "load": "Open",
    "getShareableLink": "Maak een deelbare link",
    "close": "Sluiten",
    "selectLanguage": "Taal selecteren",
    "scrollBackToContent": "Scroll terug naar inhoud",
    "zoomIn": "Inzoomen",
    "zoomOut": "Uitzoomen",
    "resetZoom": "Zoom terugzetten",
    "menu": "Menu",
    "done": "Klaar",
    "edit": "Bewerken",
    "undo": "Ongedaan maken",
    "redo": "Herstel ongedaan maken",
    "resetLibrary": "Bibliotheek Resetten",
    "createNewRoom": "Creëer live-samenwerkingssessie",
    "fullScreen": "Volledig scherm",
    "darkMode": "Donkere modus",
    "lightMode": "Lichte modus",
    "zenMode": "Zen modus",
    "objectsSnapMode": "",
    "exitZenMode": "Verlaat zen modus",
    "cancel": "Annuleren",
    "clear": "Wissen",
    "remove": "Verwijderen",
    "embed": "Insluiten in-/uitschakelen",
    "publishLibrary": "Publiceren",
    "submit": "Versturen",
    "confirm": "Bevestigen",
    "embeddableInteractionButton": "Klik voor interactie"
  },
  "alerts": {
    "clearReset": "Dit zal het hele canvas verwijderen. Weet je het zeker?",
    "couldNotCreateShareableLink": "Kon geen deelbare link aanmaken.",
    "couldNotCreateShareableLinkTooBig": "Kan geen deelbare link aanmaken: de scène is te groot",
    "couldNotLoadInvalidFile": "Kan ongeldig bestand niet laden",
    "importBackendFailed": "Importeren vanuit backend mislukt.",
    "cannotExportEmptyCanvas": "Kan geen leeg canvas exporteren.",
    "couldNotCopyToClipboard": "Kon niet naar klembord kopiëren.",
    "decryptFailed": "Kan gegevens niet decoderen.",
    "uploadedSecurly": "De upload is beveiligd met end-to-end encryptie, wat betekent dat de Excalidraw server en derden de inhoud niet kunnen lezen.",
    "loadSceneOverridePrompt": "Het inladen van een externe tekening zal je bestaande inhoud vervangen. Wil je verdergaan?",
    "collabStopOverridePrompt": "Wanneer de sessie wordt gestopt, overschrijft u de eerdere, lokaal opgeslagen tekening. Weet je het zeker?\n\n(Als je de lokale tekening wilt behouden, sluit je in plaats daarvan het browsertabblad)",
    "errorAddingToLibrary": "Kan item niet toevoegen aan de bibliotheek",
    "errorRemovingFromLibrary": "Kan item niet uit de bibliotheek verwijderen",
    "confirmAddLibrary": "Dit zal {{numShapes}} vorm(en) toevoegen aan je bibliotheek. Weet je het zeker?",
    "imageDoesNotContainScene": "Deze afbeelding lijkt geen scène gegevens te bevatten. Heb je scène embedding tijdens het exporteren ingeschakeld?",
    "cannotRestoreFromImage": "Scène kan niet worden hersteld vanuit dit afbeeldingsbestand",
    "invalidSceneUrl": "Kan scène niet importeren vanuit de opgegeven URL. Het is onjuist of bevat geen geldige Excalidraw JSON-gegevens.",
    "resetLibrary": "Dit zal je bibliotheek wissen. Weet je het zeker?",
    "removeItemsFromsLibrary": "Verwijder {{count}} item(s) uit bibliotheek?",
    "invalidEncryptionKey": "Encryptiesleutel moet 22 tekens zijn. Live samenwerking is uitgeschakeld.",
    "collabOfflineWarning": "Geen internetverbinding beschikbaar.\nJe wijzigingen worden niet opgeslagen!"
  },
  "errors": {
    "unsupportedFileType": "Niet-ondersteund bestandstype.",
    "imageInsertError": "Afbeelding invoegen mislukt. Probeer het later opnieuw...",
    "fileTooBig": "Bestand is te groot. Maximale grootte is {{maxSize}}.",
    "svgImageInsertError": "Kon geen SVG-afbeelding invoegen. De SVG-opmaak ziet er niet geldig uit.",
    "failedToFetchImage": "",
    "invalidSVGString": "Ongeldige SVG.",
    "cannotResolveCollabServer": "Kan geen verbinding maken met de collab server. Herlaad de pagina en probeer het opnieuw.",
    "importLibraryError": "Kon bibliotheek niet laden",
    "collabSaveFailed": "Kan niet opslaan in de backend database. Als de problemen blijven bestaan, moet u het bestand lokaal opslaan om ervoor te zorgen dat u uw werk niet verliest.",
    "collabSaveFailed_sizeExceeded": "Kan de backend database niet opslaan, het canvas lijkt te groot te zijn. U moet het bestand lokaal opslaan om ervoor te zorgen dat u uw werk niet verliest.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "Ingesloten elementen kunnen niet worden toegevoegd aan de bibliotheek.",
      "iframe": "",
      "image": "Ondersteuning voor het toevoegen van afbeeldingen aan de bibliotheek komt binnenkort!"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Selectie",
    "image": "Voeg afbeelding in",
    "rectangle": "Rechthoek",
    "diamond": "Ruit",
    "ellipse": "Ovaal",
    "arrow": "Pijl",
    "line": "Lijn",
    "freedraw": "Teken",
    "text": "Tekst",
    "library": "Bibliotheek",
    "lock": "Geselecteerde tool actief houden na tekenen",
    "penMode": "Pen modus - Blokkeer aanraken",
    "link": "Link toevoegen / bijwerken voor een geselecteerde vorm",
    "eraser": "Gum",
    "frame": "",
    "magicframe": "",
    "embeddable": "Web insluiten",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Canvasacties",
    "selectedShapeActions": "Acties van geselecteerde vorm",
    "shapes": "Vormen"
  },
  "hints": {
    "canvasPanning": "Om de canvas te verplaatsen, houd muiswiel of spatiebalk ingedrukt tijdens slepen, of gebruik het handgereedschap",
    "linearElement": "Klik om meerdere punten te starten, sleep voor één lijn",
    "freeDraw": "Klik en sleep, laat los als je klaar bent",
    "text": "Tip: je kunt tekst toevoegen door ergens dubbel te klikken met de selectietool",
    "embeddable": "Klink-sleep om een website-insluiting te maken",
    "text_selected": "Dubbelklik of druk op ENTER om tekst te bewerken",
    "text_editing": "Druk op Escape of CtrlOrCmd+ENTER om het bewerken te voltooien",
    "linearElementMulti": "Klik op het laatste punt of druk op Escape of Enter om te stoppen",
    "lockAngle": "Je kunt de hoek beperken door SHIFT ingedrukt te houden",
    "resize": "Houd tijdens het vergroten SHIFT ingedrukt om verhoudingen te behouden,\ngebruik ALT om vanuit het midden te vergroten/verkleinen",
    "resizeImage": "",
    "rotate": "Je kan hoeken beperken door SHIFT ingedrukt te houden wanneer je draait",
    "lineEditor_info": "Houd CtrlOrCmd en Dubbelklik of druk op CtrlOrCmd + Enter om punten te bewerken",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "Publiceer je eigen bibliotheek",
    "bindTextToElement": "Druk op enter om tekst toe te voegen",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Kan voorbeeld niet tonen",
    "canvasTooBig": "Het canvas is mogelijk te groot.",
    "canvasTooBigTip": "Tip: beweeg de verste elementen iets dichter bij elkaar."
  },
  "errorSplash": {
    "headingMain": "Fout opgetreden. Probeer <button>de pagina opnieuw laden.</button>",
    "clearCanvasMessage": "Als herladen niet werkt, probeer <button>het canvas te wissen.</button>",
    "clearCanvasCaveat": " Dit zal leiden tot verlies van je werk ",
    "trackedToSentry": "De fout met ID {{eventId}} was gevolgd op ons systeem.",
    "openIssueMessage": "We waren voorzichtig om je scène-informatie niet in de fout toe te voegen. Als je scène niet privé is, overweeg dan alstublieft het opvolgen op onze <button>bugtracker.</button> Kopieer de informatie hieronder naar de GitHub issue.",
    "sceneContent": "Scène-inhoud:"
  },
  "roomDialog": {
    "desc_intro": "Je kunt mensen uitnodigen om met je samen te werken.",
    "desc_privacy": "Geen zorgen, de sessie gebruikt end-to-end encryptie, dus wat je tekent blijft privé. Zelfs onze server zal niet kunnen zien wat je tekent.",
    "button_startSession": "Start sessie",
    "button_stopSession": "Stop sessie",
    "desc_inProgressIntro": "De live-samenwerkingssessie is nu gestart.",
    "desc_shareLink": "Deel deze link met iedereen waarmee je wil samenwerken:",
    "desc_exitSession": "Het stoppen van de sessie zal je loskoppelen van de kamer, maar je kunt lokaal doorwerken met de scène.\nPas op: dit heeft geen invloed op andere mensen en dat zij nog steeds in staat zullen zijn om samen te werken aan hun versie.",
    "shareTitle": "Neem deel aan een live samenwerkingssessie op Excalidraw"
  },
  "errorDialog": {
    "title": "Fout"
  },
  "exportDialog": {
    "disk_title": "Opslaan op schijf",
    "disk_details": "De scènegegevens exporteren naar een bestand waaruit u later kunt importeren.",
    "disk_button": "Opslaan naar bestand",
    "link_title": "Deelbare link",
    "link_details": "Exporteren als een alleen-lezen link.",
    "link_button": "Exporteer naar link",
    "excalidrawplus_description": "Sla de scène op in je Excalidraw+ werkruimte.",
    "excalidrawplus_button": "Exporteer",
    "excalidrawplus_exportError": "Kan op dit moment niet exporteren naar Excalidraw+..."
  },
  "helpDialog": {
    "blog": "Lees onze blog",
    "click": "klik",
    "deepSelect": "Deep selecteer",
    "deepBoxSelect": "",
    "curvedArrow": "Gebogen pijl",
    "curvedLine": "Kromme lijn",
    "documentation": "Documentatie",
    "doubleClick": "dubbelklikken",
    "drag": "slepen",
    "editor": "Editor",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Probleem gevonden? Verzenden",
    "howto": "Volg onze handleidingen",
    "or": "of",
    "preventBinding": "Pijlbinding voorkomen",
    "tools": "Tools",
    "shortcuts": "Sneltoetsen",
    "textFinish": "Voltooi het bewerken (teksteditor)",
    "textNewLine": "Nieuwe regel toevoegen (teksteditor)",
    "title": "Help",
    "view": "Weergave",
    "zoomToFit": "Zoom in op alle elementen",
    "zoomToSelection": "Inzoomen op selectie",
    "toggleElementLock": "",
    "movePageUpDown": "Pagina omhoog/omlaag",
    "movePageLeftRight": "Verplaats pagina links/rechts"
  },
  "clearCanvasDialog": {
    "title": "Wis canvas"
  },
  "publishDialog": {
    "title": "Publiceer bibliotheek",
    "itemName": "Itemnaam",
    "authorName": "Naam auteur",
    "githubUsername": "GitHub gebruikersnaam",
    "twitterUsername": "Twitter gebruikersnaam",
    "libraryName": "Naam bibliotheek",
    "libraryDesc": "Beschrijving van de bibliotheek",
    "website": "Website",
    "placeholder": {
      "authorName": "Je naam of gebruikersnaam",
      "libraryName": "Naam van je bibliotheek",
      "libraryDesc": "Beschrijving van je bibliotheek om mensen te helpen het gebruik ervan te begrijpen",
      "githubHandle": "",
      "twitterHandle": "",
      "website": "Link naar je persoonlijke website of elders (optioneel)"
    },
    "errors": {
      "required": "Vereist",
      "website": "Vul een geldige URL in"
    },
    "noteDescription": "<link>openbare repository</link>",
    "noteGuidelines": "<link>richtlijnen</link>",
    "noteLicense": "<link>MIT-licentie, </link>",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "Bibliotheek ingediend",
    "content": "<link>Hier</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Reset bibliotheek",
    "removeItemsFromLib": "Verwijder geselecteerde items uit bibliotheek"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Je tekeningen zijn beveiligd met end-to-end encryptie, dus Excalidraw's servers zullen nooit zien wat je tekent.",
    "link": "Blog post over end-to-end versleuteling in Excalidraw"
  },
  "stats": {
    "angle": "Hoek",
    "element": "Element",
    "elements": "Elementen",
    "height": "Hoogte",
    "scene": "Scene",
    "selected": "Geselecteerd",
    "storage": "Opslag",
    "title": "Statistieken voor nerds",
    "total": "Totaal",
    "version": "Versie",
    "versionCopy": "Klik om te kopiëren",
    "versionNotAvailable": "Versie niet beschikbaar",
    "width": "Breedte"
  },
  "toast": {
    "addedToLibrary": "Toegevoegd aan bibliotheek",
    "copyStyles": "Stijlen gekopieerd.",
    "copyToClipboard": "Gekopieerd naar het klembord.",
    "copyToClipboardAsPng": "{{exportSelection}} naar klembord gekopieerd als PNG\n({{exportColorScheme}})",
    "fileSaved": "Bestand opgeslagen.",
    "fileSavedToFilename": "Opgeslagen als {filename}",
    "canvas": "canvas",
    "selection": "selectie",
    "pasteAsSingleElement": "Gebruik {{shortcut}} om te plakken als een enkel element,\nof plak in een bestaande teksteditor",
    "unableToEmbed": "Het insluiten van deze url is momenteel niet toegestaan. Zet een probleem op GitHub om de URL op de whitelist te zetten",
    "unrecognizedLinkFormat": "De link die u hebt ingesloten komt niet overeen met het verwachte formaat. Probeer de 'embed' string van de bronsite te plakken"
  },
  "colors": {
    "transparent": "Transparant",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "Exporteren, voorkeuren en meer...",
      "center_heading": "Diagrammen. Eenvoudig. Gemaakt.",
      "toolbarHint": "Kies een tool & begin met tekenen!",
      "helpHint": "Snelkoppelingen en hulp"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
